import React from "react";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

interface PMGradingTabsProps {
  tabs: string[];
  activeTab: string;
  onTabSelect: (tab: string) => void;
  onTabRemove: (tab: string) => void;
  onAddNewTab: () => void;
  newEntityId: string;
  setNewEntityId: (id: string) => void;
  loading: Record<string, boolean>;
}

/**
 * Component for PM Grading tab navigation
 */
const PMGradingTabs: React.FC<PMGradingTabsProps> = ({
  tabs,
  activeTab,
  onTabSelect,
  onTabRemove,
  onAddNewTab,
  newEntityId,
  setNewEntityId,
  loading,
}) => {
  // Handle tab click
  const handleTabClick = (tabId: string) => {
    onTabSelect(tabId);
  };

  // Handle tab close
  const handleTabClose = (e: React.MouseEvent, tabId: string) => {
    e.stopPropagation();
    onTabRemove(tabId);
  };

  // Handle new entity ID input change
  const handleNewEntityIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewEntityId(e.target.value.toUpperCase());
  };

  // Handle form submission for new tab
  const handleAddNewTab = (e: React.FormEvent) => {
    e.preventDefault();
    if (newEntityId) {
      onAddNewTab();
    }
  };

  return (
    <>
      {/* New tab form */}
      <Row className="mb-1">
        <Col>
          <Form onSubmit={handleAddNewTab}>
            <InputGroup>
              <Form.Control
                placeholder="Enter PM ID (e.g. VDO123456)"
                value={newEntityId}
                onChange={handleNewEntityIdChange}
                aria-label="New PMID"
                aria-describedby="add-new-tab-button"
              />
              <Button
                variant="success"
                id="add-new-tab-button"
                type="submit"
                disabled={!newEntityId}
              >
                Add
              </Button>
            </InputGroup>
          </Form>
        </Col>
      </Row>

      {/* Tabs section - vertical pills like original */}
      <Nav
        variant="pills"
        className="flex-column"
        style={{ marginTop: "20px" }}
      >
        {tabs.map((tabId) => (
          <Nav.Item key={tabId}>
            <Nav.Link
              eventKey={tabId}
              active={activeTab === tabId}
              onClick={() => handleTabClick(tabId)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>
                {tabId}
                {loading[tabId] && (
                  <span
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                  />
                )}
              </span>
              <Button
                variant="danger"
                size="sm"
                onClick={(e) => handleTabClose(e, tabId)}
              >
                Close
              </Button>
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </>
  );
};

export default PMGradingTabs;
